const WARD_KEY = 'activeWardStudentId';

export function getActiveWardStudentId() {
    const v = localStorage.getItem(WARD_KEY);
    return v ? Number(v) : null;
}

export function setActiveWardStudentId(studentId) {
    if (studentId == null) localStorage.removeItem(WARD_KEY);
    else localStorage.setItem(WARD_KEY, String(studentId));
}

export function clearActiveWardStudentId() {
    localStorage.removeItem(WARD_KEY);
}
